import {Box} from '@indoqa/style-system'
import * as React from 'react'

export const KvExportsPage = () => {
  const [validOn, setValidOn] = React.useState(new Date().toISOString().slice(0, 10))
  const lohndatenHref = `/api/v1/kv/lohndaten-infos-export${validOn ? `?valid-on=${validOn}` : ''}`

  return (
    <Box p={4}>
      <h3>KV-Exports</h3>
      <Box pt={2}>
        <ul>
          <li>
            <a download href={`/api/v1/kv/docset-infos-export`}>
              Docsets
            </a>
          </li>
          <li>
            <a download href={lohndatenHref}>
              Lohndaten - Mindestlöhne
            </a>
            {' '}
            <input type="date" value={validOn} onChange={(e) => setValidOn(e.target.value)} />
          </li>
          <li>
            <a download href={`/api/v1/kv/lohndaten-teiler-export`}>
              Lohndaten - Teiler
            </a>
          </li>
        </ul>
      </Box>
    </Box>
  )
}
